var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileGeneric({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_418_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 5.5V12.8333C25.6667 13.3196 25.8598 13.7859 26.2036 14.1297C26.5474 14.4735 27.0138 14.6667 27.5 14.6667H34.8333",
    stroke: "#141C25",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1667 38.5H12.8333C11.8609 38.5 10.9282 38.1137 10.2406 37.4261C9.55296 36.7384 9.16666 35.8058 9.16666 34.8333V9.16667C9.16666 8.19421 9.55296 7.26158 10.2406 6.57394C10.9282 5.88631 11.8609 5.5 12.8333 5.5H25.6667L34.8333 14.6667V34.8333C34.8333 35.8058 34.447 36.7384 33.7594 37.4261C33.0717 38.1137 32.1391 38.5 31.1667 38.5Z",
    stroke: "#141C25",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.5H18.3333",
    stroke: "#141C25",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 23.8333H27.5",
    stroke: "#141C25",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 31.1667H27.5",
    stroke: "#141C25",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_418_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileGeneric);
export default __webpack_public_path__ + "static/media/Icon_File_Generic.6099c19a85dec3840d52ff367f5042a5.svg";
export { ForwardRef as ReactComponent };